import React from 'react';
import { IonContent, IonHeader, IonImg, IonPage, IonText } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import Toolbar from '../components/Toolbar';
import './HowToOptimizeRisk.scss';

const HowToBloodPressure : React.FC = () => {
	const { t } = useTranslation();

	return (
		<IonPage id="HowToBloodPressure-page">
			<IonHeader>
				<Toolbar title={t('HowToBloodPressure')} />
			</IonHeader>
			<IonContent fullscreen className="ion-padding">
				<IonText color="primary"><h1 className="ion-hide-xl-up"><b>{t('HowToBloodPressure')}</b></h1></IonText>
				<IonImg src={"assets/" + t('BloodPressureGif')} style={{height: "100%"}}/>
			</IonContent>
		</IonPage>
	);
};

export default HowToBloodPressure;